import React, {useState} from 'react'
import {InputText, Button} from 'usg-lib'
import axios from 'axios'
import {restUrls} from "../../../../utils/constants";
import {usePostHog} from "posthog-js/react";

const PasswordRecoveryForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const posthog = usePostHog()

  const handleRecoverInputChange = (e) => {
    setEmailAddress(e.target.value)
  }

  const handleRecoverSubmit = async () => {
    let validationErrorMessage = validate(emailAddress);
    setErrorMessage(validationErrorMessage)
    if (isSubmitting || validationErrorMessage !== '') {
      posthog?.capture('sso_password_recovery_error', {
        error: 'PreValidation',
      })

      return false;
    }

    setIsSubmitting(true)
    const formData = new FormData();
    formData.append('emailAddress', emailAddress);
    try {
      await axios.post(restUrls.passwordRecovery, formData)
      setErrorMessage('We have sent to your email address your temporary password. Please check your email.');
      posthog?.capture('sso_password_recovery_success')
    } catch (error) {
      setErrorMessage(
        'There was a problem while resetting your password. Please try again later or contact support team'
      );
      posthog?.capture('sso_password_recovery_error')
    }
    setIsSubmitting(false)

    return false;
  }

  const validate = (emailAddress) => {
    if (!emailAddress) {
      return 'Please enter a valid email address or username';
    }

    return '';
  }

  return (
    <>
      <InputText
        label="Email address or Username"
        placeholder='Email address or Username'
        name="emailAddress"
        value={emailAddress}
        onChange={e => handleRecoverInputChange(e)}
        error={errorMessage}
      />
      <Button variant="primary" onClick={handleRecoverSubmit}>
        Recover password
      </Button>
    </>
  )
}

export default PasswordRecoveryForm;
